const template = `
<div class="popup-menu">

	<div data-sticky-template="popup-menu-item" class="item">
		<a class="title"></a>

		<div data-sticky-template="popup-menu-lock" class="lock">
			<span class="subscription-notice">%subscription-notice-text%</span>	
			<span class="item-lock"></span>
		</div>

		<div data-sticky-template="popup-menu-add" class="add">
			<div class="align y"><div>
				<span class="sprite item-add"></span>
			</div></div>
		</div>

		<div data-sticky-template="popup-menu-delete" class="delete">
			<span class="sprite item-delete"></span>
		</div>

		<div data-sticky-template="popup-menu-toggle" class="toggle">
			<div class="align y"><div>
				<div class="base">
					<div class="knob"></div>
				</div>
			</div></div>
		</div>

		<div data-sticky-template="popup-menu-expand" class="expand">
			<div class="align y"><div>
				<span class="sprite item-group-expand"></span>
			</div></div>
		</div>

	</div>

	<div data-sticky-template="popup-menu-item-group" class="item-group"></div>

	<div data-sticky-template="popup-menu-delimiter" class="delimiter"></div>

</div>
`;

export default template;
